import DOMPurify from 'dompurify';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import CloseSVG from '../../../assets/svg/close.svg';
import {
  useAddBonus,
  useEditBonus,
} from '../../../redux/employees/hook/bonuses';
import { monthOptions, yearOptions } from '../../../utils/constants/date';
import { formValidation } from '../../../utils/functions';
import Button from '../../button';
import FormSelectEmployee from '../../employees/form-select-employee';
import WarningSVG from '../../../assets/svg/warning.svg';
import FormInput from '../../form-input';
import FormSelect from '../../form-select';
import Modal from '../modal';
import moment from 'moment';

function AddBonus({
  isOpen,
  closeModal,
  completed,
  refresh,
  bonusData,
  title,
  buttonText,
}) {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  });

  const { mutateAsync: addBonus, isLoading: addBonusloading } = useAddBonus();
  const { mutateAsync: editBonus, isLoading: editBonusloading } =
    useEditBonus();
  const [month, setMonth] = useState(moment().format('MM'));
  const [year, setYear] = useState(moment().format('YYYY-'));
  const [employee, setEmployee] = useState();
  const [employeeName, setEmployeeName] = useState();
  const [amountEdit, setAmountEdit] = useState();
  const [purposeEdit, setPurposeEdit] = useState();
  const [bonusId, setBonusId] = useState();
  const [bonusType, setBonusType] = useState();

  useEffect(() => {
    if (bonusData) {
      setMonth(bonusData.month.split('-')[1].toString());
      setYear(bonusData.month.split('-')[0].toString() + '-');
      setAmountEdit(parseFloat(bonusData.amount.toFixed(2)));
      setPurposeEdit(bonusData.purpose);
      setEmployee(bonusData.employee);
      setEmployeeName(bonusData.first_name + ' ' + bonusData.last_name);
      setBonusId(bonusData.id);
      setBonusType('edit');
    } else {
      setBonusType('add');
    }
  }, [bonusData]);

  const submitForm = async (data) => {
    const amount = DOMPurify.sanitize(data?.amount);
    const purpose = DOMPurify.sanitize(data?.purpose);

    if (bonusType === 'add') {
      let payload = {
        employee,
        amount,
        purpose,
        month: year + month,
      };
      await addBonus(payload).then(() => {
        completed();
      });
    } else if (bonusType === 'edit') {
      let editPayload = {
        id: bonusId,
        body: {
          employee,
          amount: amountEdit,
          purpose: purposeEdit,
          month: year + month,
          status: 2,
        },
      };
      await editBonus(editPayload).then(() => {
        completed();
      });
    }
  };

  return (
    <Modal
      scrollable={true}
      className='!max-w-[600px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <form className='form pb-4' onSubmit={handleSubmit(submitForm)}>
          <div className='flex flex-row justify-between pl-8 pr-8 pt-4 items-center'>
            <span className='header-4'>{title}</span>
            <div className='cursor-pointer' onClick={() => closeModal()}>
              <img src={CloseSVG} alt='close' />
            </div>
          </div>
          <hr className='divider mb-2' />
          <div className='flex flex-col mx-8'>
            <div>
              <div className='border bg-highlight p-2 rounded-md mb-2'>
                <FormSelectEmployee
                  label={'Employee'}
                  name='employee'
                  placeholder='Type to select Employee'
                  value={employee}
                  readOnly={bonusType === 'edit' ? true : false}
                  empName={employeeName}
                  setEmployee={setEmployee}
                />
              </div>
              <hr className='divider mb-2 mt-2' />
              <div className='text-[13px] text-color-gray -mb-2'>
                Select month And year this bonus will be added
              </div>
              <div className='flex flex-row md:flex-col w-full justify-between'>
                <div className='w-full md:w-1/2 md:pr-2'>
                  <FormSelect
                    value={month}
                    options={monthOptions}
                    onChange={(selected) => {
                      setMonth(selected);
                    }}
                  />
                </div>

                <div className='w-full md:w-1/2 md:pl-2'>
                  <FormSelect
                    value={year}
                    options={yearOptions}
                    onChange={(selected) => {
                      setYear(selected);
                    }}
                  />
                </div>
              </div>
              <div className='flex flex-row md:flex-col w-full justify-between'>
                <div className='w-full md:w-2/3 md:pr-2'>
                  <FormInput
                    label='Purpose'
                    name='purpose'
                    placeholder='Enter bonus purpose'
                    type='text'
                    readOnly={addBonusloading || editBonusloading}
                    error={errors.purpose}
                    errorMessage={errors.purpose && errors.purpose.message}
                    defaultValue={purposeEdit}
                    inputRef={register(formValidation('text', true))}
                    onInput={(e) => {
                      setPurposeEdit(e.target.value);
                    }}
                  />
                </div>

                <div className='w-full md:w-1/3 md:pl-2'>
                  <FormInput
                    label='Amount'
                    name='amount'
                    type='number'
                    placeholder={'Enter bonus amount'}
                    inputRef={register(formValidation('number', true))}
                    readOnly={addBonusloading || editBonusloading}
                    defaultValue={amountEdit}
                    onInput={(e) => {
                      setAmountEdit(e.target.value);
                    }}
                    error={errors.amount}
                    errorMessage={errors.amount && errors.amount.message}
                  />
                </div>
              </div>
            </div>
            <div className='flex flex-col justify-center'>
              <div className='flex flex-row px-4 border-secondary-4 border-[2px] rounded-lg p-2 bg-color-warning-light !text-[14px]'>
                <div className='w-[70px] pr-2 flex flex-row items-center '>
                  <img src={WarningSVG} alt='' srcSet='' />
                </div>
                <div className='text-[12px]'>
                  Please note that the Bonus with be automatically applied on the payroll for the <span className='font-extrabold'>month</span> and <span className='font-extrabold'>year</span> selected
                </div>
              </div>
            </div>
            <div className='w-full mt-[20px]'>
              <Button
                text={buttonText}
                type='submit'
                disabled={!isValid || !employee}
                loading={addBonusloading || editBonusloading}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default AddBonus;
